"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmitter = exports.createCallback = exports.bound = exports.createSocketError = exports.SocketError = exports.debug = void 0;
exports.debug = createDebug();
function createDebug() {
    try {
        return require('debug')('smartsupp:client');
    }
    catch (_a) {
        return function () { };
    }
}
var SocketError = /** @class */ (function (_super) {
    __extends(SocketError, _super);
    function SocketError(message, context) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, SocketError.prototype); // fix err instanceOf
        _this.name = _this.constructor.name;
        _this.code = context.code;
        _this.type = context.type;
        _this.event = context.event;
        if (context && context.stack) {
            _this.stack = "".concat(_this.stack, "\nCaused By: ").concat(context.stack);
        }
        return _this;
    }
    return SocketError;
}(Error));
exports.SocketError = SocketError;
function createSocketError(context) {
    return new SocketError(context.message, context);
}
exports.createSocketError = createSocketError;
function bound(scope, name) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        scope[name].apply(scope, args);
    };
}
exports.bound = bound;
function createCallback(resolve, reject) {
    return function (err, ret) {
        if (err) {
            reject(createSocketError(err));
        }
        else {
            resolve(ret);
        }
    };
}
exports.createCallback = createCallback;
function createEmitter(emitter, name) {
    return function (data) {
        emitter.emit(name, data);
    };
}
exports.createEmitter = createEmitter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQWEsUUFBQSxLQUFLLEdBQTZCLFdBQVcsRUFBRSxDQUFBO0FBRTVELFNBQVMsV0FBVztJQUNuQixJQUFJO1FBQ0gsT0FBTyxPQUFPLENBQUMsT0FBTyxDQUFDLENBQUMsa0JBQWtCLENBQUMsQ0FBQTtLQUMzQztJQUFDLFdBQU07UUFDUCxPQUFPLGNBQU8sQ0FBQyxDQUFBO0tBQ2Y7QUFDRixDQUFDO0FBTUQ7SUFBaUMsK0JBQUs7SUFLckMscUJBQVksT0FBZSxFQUFFLE9BQW9CO1FBQWpELFlBQ0Msa0JBQU0sT0FBTyxDQUFDLFNBU2Q7UUFSQSxNQUFNLENBQUMsY0FBYyxDQUFDLEtBQUksRUFBRSxXQUFXLENBQUMsU0FBUyxDQUFDLENBQUEsQ0FBQyxxQkFBcUI7UUFDeEUsS0FBSSxDQUFDLElBQUksR0FBRyxLQUFJLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQTtRQUNqQyxLQUFJLENBQUMsSUFBSSxHQUFHLE9BQU8sQ0FBQyxJQUFJLENBQUE7UUFDeEIsS0FBSSxDQUFDLElBQUksR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFBO1FBQ3hCLEtBQUksQ0FBQyxLQUFLLEdBQUcsT0FBTyxDQUFDLEtBQUssQ0FBQTtRQUMxQixJQUFJLE9BQU8sSUFBSSxPQUFPLENBQUMsS0FBSyxFQUFFO1lBQzdCLEtBQUksQ0FBQyxLQUFLLEdBQUcsVUFBRyxLQUFJLENBQUMsS0FBSywwQkFBZ0IsT0FBTyxDQUFDLEtBQUssQ0FBRSxDQUFBO1NBQ3pEOztJQUNGLENBQUM7SUFDRixrQkFBQztBQUFELENBQUMsQUFoQkQsQ0FBaUMsS0FBSyxHQWdCckM7QUFoQlksa0NBQVc7QUFrQnhCLFNBQWdCLGlCQUFpQixDQUFDLE9BQW9CO0lBQ3JELE9BQU8sSUFBSSxXQUFXLENBQUMsT0FBTyxDQUFDLE9BQU8sRUFBRSxPQUFPLENBQUMsQ0FBQTtBQUNqRCxDQUFDO0FBRkQsOENBRUM7QUFFRCxTQUFnQixLQUFLLENBQUMsS0FBSyxFQUFFLElBQUk7SUFDaEMsT0FBTztRQUFDLGNBQU87YUFBUCxVQUFPLEVBQVAscUJBQU8sRUFBUCxJQUFPO1lBQVAseUJBQU87O1FBQ2QsS0FBSyxDQUFDLElBQUksQ0FBQyxPQUFYLEtBQUssRUFBVSxJQUFJLEVBQUM7SUFDckIsQ0FBQyxDQUFBO0FBQ0YsQ0FBQztBQUpELHNCQUlDO0FBRUQsU0FBZ0IsY0FBYyxDQUFDLE9BQU8sRUFBRSxNQUFNO0lBQzdDLE9BQU8sVUFBQyxHQUFHLEVBQUUsR0FBRztRQUNmLElBQUksR0FBRyxFQUFFO1lBQ1IsTUFBTSxDQUFDLGlCQUFpQixDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUE7U0FDOUI7YUFBTTtZQUNOLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQTtTQUNaO0lBQ0YsQ0FBQyxDQUFBO0FBQ0YsQ0FBQztBQVJELHdDQVFDO0FBRUQsU0FBZ0IsYUFBYSxDQUFDLE9BQXNCLEVBQUUsSUFBWTtJQUNqRSxPQUFPLFVBQUMsSUFBSTtRQUNYLE9BQU8sQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxDQUFBO0lBQ3pCLENBQUMsQ0FBQTtBQUNGLENBQUM7QUFKRCxzQ0FJQyJ9